<template>
    <v-container id="extended-tables" fluid tag="section">
        <base-v-component heading="" link="componetns/simple-tables" />

        <base-material-card color="success" icon="mdi-clipboard-text" inline title="Balance General"
            class="px-5 py-3 mb-5">
            <v-row>
                <v-col cols="12" md="12" class="mt-10">
                    <!--
          <v-select v-model="urbanizacion" outlined :items="urbanizaciones" label="Urbanizaciones" item-text="name"
            item-value="id" persistent-hint return-object single-line v-on:change="listar()"></v-select> -->
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12" class="mt-10">
                    <v-data-table :headers="headers" :items="details" sort-by="calories" class="elevation-1"
                        :search="search" :loading="loadingTable" loading-text="Cargando... Por favor esperar">
                        <template v-slot:item.totalAccountsReceivable="{ item }">
                            {{ formatCurrency(item.totalAccountsReceivable) }}
                        </template>
                           <template v-slot:item.totalReceived="{ item }">
                            {{ formatCurrency(item.totalReceived) }}
                        </template>
                           <template v-slot:item.receivableBalance="{ item }">
                            {{ formatCurrency(item.receivableBalance) }}
                        </template>
                           <template v-slot:item.totalAccountsPayable="{ item }">
                            {{ formatCurrency(item.totalAccountsPayable) }}
                        </template>
                           <template v-slot:item.totalPaidPayable="{ item }">
                            {{ formatCurrency(item.totalPaidPayable) }}
                        </template>
                           <template v-slot:item.payableBalance="{ item }">
                            {{ formatCurrency(item.payableBalance) }}
                        </template>
                            <template v-slot:item.netBalance="{ item }">
                            {{ formatCurrency(item.netBalance) }}
                        </template>
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Resumen </v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                                    hide-details></v-text-field>

                                <v-spacer></v-spacer>


                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" large @click="editar(item)">
                                        <v-icon dense color="secondary">mdi-pencil</v-icon>
                                    </v-btn>
                                </template>
                                <span>Editar datos</span>
                            </v-tooltip>

                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" large @click="deleteItem(item)">
                                        <v-icon dense color="primary">mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Eliminar Edificio</span>
                            </v-tooltip>
                        </template>

                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize"> Recargar </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>

        </base-material-card>

        <v-snackbar v-model="snackbar" :timeout="timeout">
            {{ text }}

            <template v-slot:action="{ attrs }">
                <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import axios from "axios";
export default {
    name: "DashboardExtendedTables",

    data: () => ({

        headers: [
            { text: "Edificio", value: "buildingName" },
            { text: "Total Cuentas por Cobrar", value: "totalAccountsReceivable" },
            { text: "Total Pagado", value: "totalReceived" },
            { text: "Saldo por cobrar", value: "receivableBalance" },
            { text: "Total CUentas por pagar", value: "totalAccountsPayable" },
            { text: "Total pagado", value: "totalPaidPayable" },
            { text: "Saldo por pagar", value: "payableBalance" },
            { text: "Balance Neto", value: "netBalance" },
            //{ text: "actions", value: "actions", sortable: false }
        ],
        details: [],


        search: "",
        loadingTable: false,
        snackbar: false,
        text: "",
        timeout: 6000,






    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nuevo edificio" : "Editar edificio";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
        loader() {
            const l = this.loader;
            this[l] = !this[l];

            setTimeout(() => (this[l] = false), 6000);

            this.loader = null;
        },
    },

    created() {
        this.initialize();
    },

    methods: {
        initialize() {
            //this.listarUrbanizaciones()
            this.listar();
        },
        // Formatea como moneda con "$" y 2 decimales
        formatCurrency(value) {
            if (value == null) return "$0.00";
            return `$${parseFloat(value).toFixed(2)}`;
        },


        listar() {
            let me = this;

            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            me.loadingTable = true;
            axios
                .get("api/Balances/GeneralBalance", configuracion)
                .then(function (response) {
                    me.details = response.data;
                    //change to string bool value
                    me.loadingTable = false;
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                }
                );
        },
    }


};
</script>